import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import CaseTypeOrganizationUnit from './CaseTypeOrganizationUnit';

interface Props {
	isOpened: boolean;
	onClose: () => void;
	onSuccess: () => void;
	organizationUnitId?: string;
	workplaceId: string;
	isOnlyOneRoot: boolean;
}

const CaseTypeOrganizationUnitModal: React.FC<Props> = ({
	isOpened,
	onClose,
	onSuccess,
	organizationUnitId,
	workplaceId,
	isOnlyOneRoot,
}) => {
	return (
		<Modal opened={isOpened} onClose={onClose} size={Size.SM}>
			<Modal.Header
				title={
					organizationUnitId
						? 'component.caseType.editManagementUnit'
						: 'component.caseType.addManagementUnit'
				}
				firstUpper
			/>
			<Modal.Content contentScroll={true}>
				<CaseTypeOrganizationUnit
					organizationUnitId={organizationUnitId}
					onSuccess={onSuccess}
					workplaceId={workplaceId}
					isOnlyOneRoot={isOnlyOneRoot}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default CaseTypeOrganizationUnitModal;
